import { useStyletron } from 'parkdepot-shared/theme'
import Carousel from 'nuka-carousel'
import React, { FC, useMemo } from 'react'
import { Container, Image, ArrowIcon } from './ImagesGallery.style'

export interface GalleryImage {
    src: string
    alt: string
}

interface Props {
    images: GalleryImage[]
}

const ImagesGallery: FC<Props> = ({ images }) => {
    const [css, theme] = useStyletron()

    if (!images || !images.length) return null
    return (
        <Container>
            <Carousel
                autoplay={false}
                autoplayInterval={5000}
                pauseOnHover
                wrapAround
                className={css({
                    [theme.mediaQuery.large]: {
                        borderRadius: '16px'
                    }
                })}
                defaultControlsConfig={{
                    pagingDotsStyle: {
                        fill: '#fff'
                    }
                }}
                speed={800}
                renderCenterLeftControls={({ previousSlide }) => (
                    <ArrowIcon onClick={previousSlide} className="wemolo-chevron-left" $left />
                )}
                renderCenterRightControls={({ nextSlide }) => (
                    <ArrowIcon onClick={nextSlide} className="wemolo-chevron-right" />
                )}
            >
                {images.map((image) => (
                    <Image key={image.src} src={image.src} alt={image.alt} />
                ))}
            </Carousel>
        </Container>
    )
}

export default ImagesGallery
